module.exports = __webpack_public_path__ + "static/media/OutliersQ4_5.5a9c3235.svg";